import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import About from './pages/About';
import NotFound from './pages/NotFound';
import Student from './pages/Student';
import Login from "./Login";
import ProtectedRoute from "./ProtectedRoute";
import Layout from "./components/Layout";
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="/project/about" element={<About />} />
            <Route path="/student" element={<Student />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Route>        
      </Routes>
    </Router>
  );
}

export default App;
